export default __webpack_public_path__ + "static/media/usp_2.e3758fe1.svg";